import { makeStyles } from '@mui/styles';

export const useStylesMenu = makeStyles(theme => ({
  paper: {
    marginTop: 25,
    width: '90%',
    left: '5%',
    borderRadius: '12px',
    backgroundColor: theme.colors.dark.darkSlateBlue,
    color: theme.palette.common.white,
  },
}));

export const useStylesMenuItem = makeStyles(theme => ({
  root: {
    '&:focus': {
      backgroundColor: theme.colors.dark.darkNavy,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}));

export const useStylesMask = makeStyles(theme => ({
  root: {
    background: theme.colors.dark.darkMask,
    backdropFilter: 'blur(14px)',
  },
}));
